import { render } from "./SellerOrderDetails.vue?vue&type=template&id=24e145c3&scoped=true"
import script from "./SellerOrderDetails.vue?vue&type=script&lang=js"
export * from "./SellerOrderDetails.vue?vue&type=script&lang=js"

import "./SellerOrderDetails.vue?vue&type=style&index=0&id=24e145c3&lang=less&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e145c3"]])

export default __exports__